interface Props {
  previews: string[]
  onRemove: (index: number) => void
}

export function PhotoPreview({ previews, onRemove }: Props) {
  return (
    <div className="flex items-end gap-1.5 mb-2 ml-[2.4rem] pl-xs">
      {previews.map((preview, i) => (
        <div key={i} className="relative">
          <img
            src={preview}
            alt={`Zdjęcie ${i + 1}`}
            className="h-[3.25rem] w-[3.25rem] rounded-md object-cover border border-frame"
          />
          <button
            type="button"
            onClick={() => onRemove(i)}
            className="absolute -top-1.5 -right-1.5 flex h-[1.1rem] w-[1.1rem] items-center justify-center rounded-full bg-danger text-white text-[0.6rem] leading-none border-none cursor-pointer"
          >
            &times;
          </button>
        </div>
      ))}
      {previews.length > 0 && (
        <span className="text-[0.65rem] text-frame pb-0.5">{previews.length}/5</span>
      )}
    </div>
  )
}
